/**
 * RMKM Phase 2 Changes
 * added by @Jaseem 
 * date : 18 April 2025
 * PDF WORK
 *  */

import React, { useEffect, useState } from 'react';
const getBase64ImageFromURL = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
};

export const GDTScoringPdf = ({ GDTScoringData }) => {
  console.log("GDTScoringData",GDTScoringData);
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      const base64Images = await Promise.all(
        GDTScoringData.map(async (item) => {
          const base64 = await getBase64ImageFromURL(item.path);
          return { ...item, base64 };
        })
      );
      setImages(base64Images);
    };

    loadImages();
  }, [GDTScoringData]);

  return (
    <div className="d-flex justify-content-center border" style={{ fontSize: "10px" }}>
        <h5 style={{textAlign: 'center'}}>GDT SCORING</h5>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{textAlign: 'center'}}>IMAGE</th>
            <th style={{textAlign: 'center'}}>AGE</th>
            <th style={{textAlign: 'center'}}>YEARS</th>
          </tr>
        </thead>
        <tbody>
          {images.map((item, index) => (
            <tr key={index}>
              <td style={{ border: "1px solid gray", paddingTop: "50px", width: '30%', height: "80px", textAlign: 'center' }}>
                <img src={item.base64} alt={`Image ${index + 1}`} style={{ maxWidth: '100px', maxHeight: '80px', paddingTop: "50%", textAlign: 'center' }} />
              </td>
              <td style={{ border: "1px solid gray", paddingTop: "50px", width: '30%', height: "80px", textAlign: 'center' }}>{index + 2 === 11 ? index + 3 : index + 2}</td>
              <td style={{ border: "1px solid gray", paddingTop: "50px", width: '30%', height: "80px", textAlign: 'center' }}>{item.marks}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

//=============== Ended =====================
